import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { JsonPipe } from '@angular/common';
import Swal from 'sweetalert2'
import { SelectedProductService } from '../main-content/sevices/selected-product.service';
import { StateService } from '../main-content/sevices/state.service';
import { ProductService } from '../main-content/sevices/product.service';
import { NotificationService } from '../../app/_services/notification.service';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';
import { PhotoSwipeComponent } from './photo-swipe/photo-swipe.component';
import { environment } from 'src/environments/environment';
export interface IImage {
    src: string,
    w: number,
    h: number,
}
@Component({
    selector: 'app-productdetail',
    templateUrl: './productdetail.component.html',
    styleUrls: ['./productdetail.component.scss']
})

export class ProductdetailComponent implements OnInit {
    @ViewChild('photoSwipe') photoSwipe: PhotoSwipeComponent;
    @Input() public item: any;
    @Input() public state: string;
    @Output() event: EventEmitter<string> = new EventEmitter();

    @Input() images: IImage[] = [];

    public goodbye = "Goodbye friends";
    public ItemDetails: any;
    localProductDetail;
    ProductName;
    GlobalImage;
    similarproduct;
    allProductDetailNewWithAttr = [];
    SelecteditemDetail = [];

    AllCartItems = [];
    public CartProductsCounter = 0;
    shoppingCart = [];

    showloader = true;



    constructor(private route: ActivatedRoute, private productService: ProductService, private notifyService: NotificationService, private stateService: StateService, private router: Router, private selectedProductService: SelectedProductService) {


    }

    isLoaded = false;

    productId: any = {};
    ngOnInit() {
        debugger;
        this.route.queryParamMap
            .subscribe((params) => {

                var allPrams = { ...params.keys, ...params };
                this.productId = allPrams["params"].productId;
                this.productService.getProductDetail(parseInt(this.productId)).subscribe(resp => {

                    this.ItemDetails = resp.allAttributes[0];
                    this.ItemDetails.selectedQuantity = 1;

                    this.ItemDetails.productImage.forEach(element => {
                        this.GlobalImage = environment.globalImagePath;
                        this.images.push({
                            src: this.GlobalImage + "/ProductImages/Large/" + element.imagepath,
                            w: 1000,
                            h: 500
                        });
                    });

                    this.isLoaded = true;


                });
            }
            );

    }

    openSlideShow() {
        this.photoSwipe.openGallery(this.images);

    }

    sendtoparent() {
        this.event.emit(this.goodbye);
    }



    GetProductImage(Path) {
        if (Path != undefined) {
            this.GlobalImage = environment.globalImagePath;

            return this.GlobalImage + "/ProductImages/Large/" + Path;

        } else {

            return "../img/no-image.png";
        }
    }



    updateCart(type, item) {
        debugger;
        if (type == "plus") {
            this.ItemDetails.selectedQuantity = this.ItemDetails.selectedQuantity + 1;
        } else {
            if (item.selectedQuantity >= 2)
                this.ItemDetails.selectedQuantity = this.ItemDetails.selectedQuantity - 1;
        }
        // this.getTotal();

    }
    addToCart(currentItem) {
        debugger;
        currentItem.isAddedToCart = true;
        this.selectedProductService.add(currentItem);
        this.notifyService.showSuccess("Add to Card Succcessfully", currentItem.ProductName)
    }

    // addToCart(currentItem) {
    //     debugger;
    //     this.selectedProductService.items.forEach(element => {

    //         if (element.ROWID != currentItem.ROWID) {
    //             if (element.ROWID != currentItem.ROWID) {
    //                 this.selectedProductService.add(currentItem);
    //             }
    //         }
    //         // else {

    //         // }
    //     });

    //     if (this.selectedProductService.items.length == 0) {
    //         this.selectedProductService.add(currentItem);
    //     }

    // }
}
